import Vue from "vue";
import { VDataTable, VSimpleTable } from "vuetify/lib/components/VDataTable";
import { VTextField } from "vuetify/lib/components/VTextField";
import { VSelect } from "vuetify/lib/components/VSelect";

function getTextFilterValue(filters, filterCol) {
  let filter = filters.find(filter => {
    if (filter.split("|")[0] == filterCol.name) {
      return filter.split("|")[1];
    }
  });
  if (filter) {
    return filter.split("|")[1];
  }
}

function getSelectFilterValue(filters, filterCol) {
  // Vue.nextTick(() => {
  let filter = filters.find(filter => {
    if (filter.split("|")[0] == filterCol.name) {
      return parseInt(filter.split("|")[1]);
    }
  });
  if (filter) {
    return parseInt(filter.split("|")[1]);
  }
  // });
}

export default {
  extends: VDataTable,
  props: {
    filterCols: {
      type: Array,
      default: () => {
        return [];
      }
    },
    filters: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      query: new Map()
    };
  },
  methods: {
    genDefaultScopedSlot(props) {
      const simpleProps = {
        height: this.height,
        fixedHeader: this.fixedHeader,
        dense: this.dense
      };

      return this.$createElement(
        VSimpleTable,
        {
          props: simpleProps
        },
        [
          this.proxySlot("top", this.genTops(props)),
          this.genCaption(props),
          this.genColgroup(props),
          this.genHeaders(props),
          this.genBody(props),
          this.proxySlot("bottom", this.genFooters(props))
        ]
      );
    },
    genTops(props) {
      return [
        this.$createElement(
          "div",
          {
            class: "row pa-0 ma-0 grey lighten-4"
          },
          this.filterCols.map(filterCol => {
            switch (filterCol.type) {
              case "text":
                return this.$createElement(
                  "div",
                  {
                    class: "col-sm-4 col-md-2 col-lg-2 col-12"
                  },
                  [
                    this.$createElement(VTextField, {
                      props: {
                        appendIcon: "mdi-magnify",
                        class: "ml-auto",
                        label: filterCol.title
                          ? filterCol.title
                          : this.$vuetify.lang.t(filterCol.name),
                        hideDatails: true,
                        singleLine: true,
                        style: "max-width: 250px;",
                        value: getTextFilterValue(this.filters, filterCol)
                      },
                      on: {
                        input: val => this.updateQuery(filterCol.name, val)
                      }
                    })
                  ]
                );
                case "date":
                  return this.$createElement(
                    "div",
                    {
                      class: "col-sm-4 col-md-2 col-lg-2 col-12"
                    },
                    [
                      this.$createElement(VTextField, {
                        props: {
                          class: "ml-auto",
                          type: "date",
                          clearable: true,
                          label: filterCol.title
                            ? filterCol.title
                            : this.$vuetify.lang.t(filterCol.name),
                          hideDatails: true,
                          singleLine: true,
                          style: "max-width: 250px;",
                          value: getTextFilterValue(this.filters, filterCol)
                        },
                        on: {
                          input: val => this.updateQuery(filterCol.name, val)
                        }
                      })
                    ]
                  );
              case "select":
                return this.$createElement(
                  "div",
                  {
                    class: "col-sm-4 col-md-2 col-lg-2 col-12"
                  },
                  [
                    this.$createElement(VSelect, {
                      attrs: {
                        "aria-label": "4"
                      },
                      props: {
                        disabled: false,
                        items: filterCol.items,
                        label: filterCol.title
                          ? filterCol.title
                          : this.$vuetify.lang.t(filterCol.name),
                        hideDetails: true,
                        auto: true,
                        minWidth: "75px",
                        clearable: true,
                        ...filterCol.props,
                        value: getSelectFilterValue(this.filters, filterCol)
                      },
                      on: {
                        input: val => this.updateQuery(filterCol.name, val)
                      }
                    })
                  ]
                );
              default:
                break;
            }
          })
        )
      ];
    },
    updateQuery(row, value) {
      if (value || value === 0) {
        this.query.set(row, value);
      } else {
        this.query.delete(row);
      }
      let filters = [];
      this.query.forEach((val, key) => {
        filters.push(key + "|" + val);
      });
      this.$emit("filter", filters);
    }
  }
};
